"use client"

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { FreeMode, Navigation } from 'swiper/modules';
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils';
import { type TripSliderData } from '@/types/trip.type';
import TripCard from './trip-card';

interface TripSliderProps {
    navigationBtn: string
    data: TripSliderData
    isTrips: boolean
    slug?: string
}

const TripSlider = ({ navigationBtn, data, slug, isTrips }: TripSliderProps) => {

    const tripPrev = `${navigationBtn}Prev`
    const tripNext = `${navigationBtn}Next`

    const filteredData = slug ? data.filter(item => item.slug !== slug) : data;

    return (
        <div className='relative h-full  w-full'>
            <Swiper
                breakpoints={{
                    200: {
                        slidesPerView: 1,
                        spaceBetween: 12
                    },
                    350: {
                        slidesPerView: 1.1,
                        spaceBetween: 10
                    },
                    420: {
                        slidesPerView: 1.3,
                        spaceBetween: 16
                    },
                    460: {
                        slidesPerView: 1.4,
                        spaceBetween: 16
                    },
                    550: {
                        slidesPerView: 1.7,
                        spaceBetween: 16
                    },
                    650: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    750: {
                        slidesPerView: 2.3,
                        spaceBetween: 20
                    },
                    850: {
                        slidesPerView: 2.6,
                        spaceBetween: 20
                    },
                    1000: {
                        slidesPerView: 3,
                        spaceBetween: 16
                    },
                    1200: {
                        slidesPerView: 3.3,
                        spaceBetween: 20
                    },
                    1400: {
                        slidesPerView: 4,
                        spaceBetween: 24
                    },
                }}
                navigation={{
                    prevEl: `.${tripPrev}`,
                    nextEl: `.${tripNext}`,
                }}
                freeMode={true}
                modules={[Navigation, FreeMode]}
                className="mySwiper"
            >
                {filteredData.map((data) => (
                    <SwiperSlide key={data.slug}>
                        <TripCard data={data} isTrips={isTrips} />
                    </SwiperSlide>
                ))}
            </Swiper>
            <button className={cn('absolute top-1/2  -translate-x-1/2 left-0 -translate-y-1/2 z-20 lg:h-8 lg:w-8 md:h-7 md:w-7 h-6 w-6 p-0.5 lg:p-1 rounded-full bg-white text-custom-primary hover:bg-custom-primary hover:text-white transition-all duration-300 ease-in-out shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] hover:shadow-none disabled:hidden hidden md:block', tripPrev)}><ChevronLeft className='h-full w-full' /></button>
            <button className={cn('absolute top-1/2 translate-x-1/2 right-0 -translate-y-1/2 z-20 lg:h-8 lg:w-8 md:h-7 md:w-7 h-6 w-6 p-0.5 lg:p-1 rounded-full bg-white text-custom-primary hover:bg-custom-primary hover:text-white transition-all duration-300 ease-in-out shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] hover:shadow-none disabled:hidden hidden md:block', tripNext)}><ChevronRight className='h-full w-full' /></button>
        </div>
    )
}

export default TripSlider